import React from "react";
import { Box, Typography, Tabs, Tab } from "@mui/material";
import { useTranslation } from "react-i18next";
import N01RegistrationForm from "../form/N01RegistrationForm";
import LegalPersonRegstrationForm from "../form/LegalPersonRegistrationForm";
import BackButton from "src/shared/components/Buttons/BackButton";

const NonGemiRegistrationForm = () => {
  const { t } = useTranslation();

  const [tab, setTab] = React.useState(0);

  const handleChange = (event: any, newValue: any) => {
    setTab(newValue);
  };

  return (
    <>
      <BackButton title={t("Μετάβαση στην αρχική οθόνη")} to="/" />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "80vw",
          mx: "auto",
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: "500" }}>
          {t("Εγγραφή χρήστη για λήψη πιστοποιητικών και αντιγράφων στο ΓΕΜΗ")}
        </Typography>

        <Box
          sx={{
            mt: 5,
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              variant="scrollable"
              scrollButtons="auto"
              value={tab}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab label={t("Φυσικό Πρόσωπο")} />
              <Tab label={t("Νομικό Πρόσωπο μη Υπόχρεο στο Γ.Ε.ΜΗ")} />
            </Tabs>
          </Box>
          <Box sx={{ mt: 5, width: "100%" }}>
            {tab == 0 ? (
              <N01RegistrationForm />
            ) : (
              <LegalPersonRegstrationForm />
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default NonGemiRegistrationForm;
